/**
 * Focus rings via tabIndex, Enter/Space on nav controls.
 * Used by carousel.js after slide changes and on resize.
 */

export const isRtlDocument = () =>
    document.body.classList.contains('rtl') || document.documentElement.getAttribute('dir') === 'rtl';

export const onActivateKey = (event, callback) => {
    if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        callback(event);
    }
};

/** False when hidden, aria-hidden, or display:none in the tree (via checkVisibility). */
export const isVisibleForKeyboard = (element) => {
    if (!element || element.hidden || element.getAttribute('aria-hidden') === 'true') {
        return false;
    }

    if (typeof element.checkVisibility === 'function') {
        return element.checkVisibility({ checkVisibilityCSS: true });
    }

    return true;
};

export const setArrowGroupState = (arrows, enabled) => {
    arrows.forEach((arrow) => {
        arrow.classList.toggle('is-active', enabled);
        arrow.setAttribute('aria-disabled', enabled ? 'false' : 'true');
        arrow.tabIndex = enabled && isVisibleForKeyboard(arrow) ? 0 : -1;
    });
};

export const applyBulletsTabFocus = (bullets, navEnabled) => {
    bullets.forEach((bullet) => {
        const allow = navEnabled && !bullet.hidden;
        bullet.tabIndex = allow && isVisibleForKeyboard(bullet) ? 0 : -1;
    });
};

const bindPressable = (element, onActivate) => {
    element.setAttribute('role', 'button');
    const go = () => onActivate();

    element.addEventListener('click', (e) => {
        e.preventDefault();
        go();
    });
    element.addEventListener('keydown', (e) => onActivateKey(e, go));
};

export const bindDirectionalArrows = (arrows, delta, changeSlide) => {
    arrows.forEach((arrow) =>
        bindPressable(arrow, () => {
            if (!arrow.classList.contains('is-active')) return;
            changeSlide(delta);
        }),
    );
};

export const bindCarouselBullets = (bullets, changeSlide) => {
    bullets.forEach((bullet, index) =>
        bindPressable(bullet, () => {
            if (bullet.hidden) return;
            changeSlide(index, true);
        }),
    );
};
